import React, { useEffect } from "react";
import { useWorkflowContext } from "../../WorkflowContextProvider";
import MultiDimensionChipPropertiesModal from "../MultiDimensionChipPropertiesModal";
import { useVariablesContext } from "../context/variableContext";
import DateConfiguration from "./DateConfiguration";
import DropdownConfiguration from "./DropdownConfiguration";
import InputConfiguration from "./InputConfiguration";
import NumberConfiguration from "./NumberConfiguration";

/**
 * Renders chip configuration; mounts MultiDimensionChipPropertiesModal here (same pattern as SwitchNodePopup → ExpressionBuilderModal)
 * so the overlay works in workflow Chips tab and in form builder Properties.
 * Share URL: see multiDimensionChipConfig in config/constants.js
 */
const VariableConfiguration = ({
  isFormVariable,
  usedWorkflowVariableIds = [],
  onRemoveFromForm,
  formData,
  formId,
  onPanelClose,
  showClickToRemoveFromFormBanner = true,
  handleShowIfChange = () => {},
}) => {
  const { selectedVariable } = useWorkflowContext();
  const { setShowMultiDimensionChipModal } = useVariablesContext();
  const type = selectedVariable?.variableType || selectedVariable?.type;

  useEffect(() => {
    setShowMultiDimensionChipModal(false);
  }, [selectedVariable?.id]);

  const getVariableConfig = (type) => {
    switch (type) {
      case "dropdown":
        return (
          <DropdownConfiguration
            isFormVariable={isFormVariable}
            usedWorkflowVariableIds={usedWorkflowVariableIds}
            onRemoveFromForm={onRemoveFromForm}
            formData={formData}
            formId={formId}
            onPanelClose={onPanelClose}
            showClickToRemoveFromFormBanner={showClickToRemoveFromFormBanner}
            handleShowIfChange={handleShowIfChange}
          />
        );
      case "text":
        return (
          <InputConfiguration
            isFormVariable={isFormVariable}
            usedWorkflowVariableIds={usedWorkflowVariableIds}
            onRemoveFromForm={onRemoveFromForm}
            formData={formData}
            formId={formId}
            onPanelClose={onPanelClose}
            showClickToRemoveFromFormBanner={showClickToRemoveFromFormBanner}
            handleShowIfChange={handleShowIfChange}
          />
        );
      case "date":
        return (
          <DateConfiguration
            isFormVariable={isFormVariable}
            usedWorkflowVariableIds={usedWorkflowVariableIds}
            onRemoveFromForm={onRemoveFromForm}
            formData={formData}
            formId={formId}
            onPanelClose={onPanelClose}
            showClickToRemoveFromFormBanner={showClickToRemoveFromFormBanner}
            handleShowIfChange={handleShowIfChange}
          />
        );
      case "number":
        return (
          <NumberConfiguration
            isFormVariable={isFormVariable}
            usedWorkflowVariableIds={usedWorkflowVariableIds}
            onRemoveFromForm={onRemoveFromForm}
            formData={formData}
            formId={formId}
            onPanelClose={onPanelClose}
            showClickToRemoveFromFormBanner={showClickToRemoveFromFormBanner}
            handleShowIfChange={handleShowIfChange}
          />
        );
      default:
        break;
    }
  };
  return (
    <>
      {getVariableConfig(type)}
      <MultiDimensionChipPropertiesModal />
    </>
  );
};

export default VariableConfiguration;
